<script>
export default {
  props: {
    LabText: {
      type: String,
      default: ''
    },
    Labbold: {}
  },
  computed: {
    // 控制按鈕的型別
    computedLabbold() {
      return this.Labbold === 'true' ? 'word-bold' : ''
    }
  }
}
</script>

<template>
  <label :class="[computedLabbold]">
    {{ LabText }}<br />
    <slot name="small" />
  </label>
</template>
